var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.71 6.012h10c2.75 0 5 2.25 5 5v10c0 2.749-2.25 5-5 5h-10c-2.749 0-5-2.251-5-5v-10c0-2.75 2.251-5 5-5Zm10.002 18.332a3.337 3.337 0 0 0 3.333-3.333v-10a3.337 3.337 0 0 0-3.333-3.333h-10A3.337 3.337 0 0 0 8.38 11.01v10a3.337 3.337 0 0 0 3.333 3.333h10Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.125,
    cy: 10.596,
    r: 1.25,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.71 16.012a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm1.667-.001a3.333 3.333 0 1 0 6.667 0 3.333 3.333 0 0 0-6.667 0Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic-instagram.d25f6f01175b69a2f56bb007205dd72d.svg";
export { ForwardRef as ReactComponent };